module.exports = __webpack_public_path__ + "img/bruxelles_2019_2.5bc9ce3d.jpeg";